module.exports = __webpack_public_path__ + "static/media/calicon.e16b441f.png";